module.exports = __webpack_public_path__ + "static/img/AS.aa23491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/AS.png
// module id = H97d
// module chunks = 1